import styled, { keyframes, css } from "styled-components";

export const MapaDiv = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  height: 100dvh;

  .map-container {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .mapboxgl-ctrl,
  .mapboxgl-ctrl-group {
    margin: 57px 12px 0 0;
  }

  #marked,
  #you {
    z-index: 1;
  }

  /* Popup styling */
  .mapboxgl-popup {
    z-index: 1000;
  }

  .mapboxgl-popup-content {
    border-radius: ${({ theme }) => theme.radius.lg};
    box-shadow: ${({ theme }) => theme.shadows.xl};
    padding: ${({ theme }) => theme.space[4]};
    font-family: ${({ theme }) => theme.fonts.family};
  }

  .mapboxgl-popup-close-button {
    right: 8px;
    top: 8px;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.gray400};
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${({ theme }) => theme.radius.full};

    &:hover {
      background: ${({ theme }) => theme.colors.gray100};
      color: ${({ theme }) => theme.colors.gray700};
    }
  }

  /* Point markers */
  .marker {
    font-family: ${({ theme }) => theme.fonts.family};
    font-size: ${({ theme }) => theme.fonts.xs};
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 6px rgba(0,0,0,0.15);
    transition: transform 150ms ease;

    &:hover {
      transform: scale(1.15);
    }
  }
`;

const pulseAttention = keyframes`
  0%, 100% {
    background: #213f9a;
    color: #ffffff;
    box-shadow: 0 0 0 0 rgba(33,63,154,0.4);
  }
  50% {
    background: #3a5bc7;
    color: #ffffff;
    box-shadow: 0 0 0 8px rgba(33,63,154,0);
  }
`;

export const InfoButton = styled.button`
  position: absolute;
  bottom: ${({ theme }) => theme.space[4]};
  left: ${({ theme }) => theme.space[4]};
  z-index: ${({ theme }) => theme.zIndex.dropdown};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[2]};
  padding: ${({ theme }) => theme.space[2]} ${({ theme }) => theme.space[4]};
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.primary};
  border: none;
  border-radius: ${({ theme }) => theme.radius.full};
  box-shadow: ${({ theme }) => theme.shadows.lg};
  font-size: ${({ theme }) => theme.fonts.sm};
  font-weight: 600;
  font-family: ${({ theme }) => theme.fonts.family};
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions.fast};

  ${({ pulse }) => pulse && css`
    animation: ${pulseAttention} 1s ease-in-out 4;
  `}

  &:hover {
    background: ${({ theme }) => theme.colors.primaryBg};
    transform: translateY(-1px);
    box-shadow: ${({ theme }) => theme.shadows.xl};
  }

  &:active {
    transform: translateY(0);
  }
`;

export const MapActionBtn = styled.button`
  position: absolute;
  top: ${({ top }) => top || '60px'};
  right: ${({ theme }) => theme.space[4]};
  z-index: ${({ theme }) => theme.zIndex.dropdown};
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.primary};
  border: none;
  border-radius: ${({ theme }) => theme.radius.md};
  box-shadow: ${({ theme }) => theme.shadows.md};
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions.fast};
  font-size: 22px;

  &:hover {
    background: ${({ theme }) => theme.colors.gray50};
    box-shadow: ${({ theme }) => theme.shadows.lg};
  }

  &:active {
    background: ${({ theme }) => theme.colors.gray100};
  }
`;
